<template>
        <div v-if="device =='web'">
          <div class="midlist-bar" v-if="configLists">
            <div class="midlist-img">
              <img src="@/assets/images/home/PC-middle.png"/>
            </div>
            <div class="midlist-content">
              <div class="emoji"></div>
              <div class="text">{{ midItem.copywriting }}</div>
              <div class="button">
                <router-link :to="{ path: midItem.url }">
                  {{ midItem.button_text }}
                </router-link>
              </div>
            </div>
          </div>
          <div class="recomList-bar" v-if="recomList">
            <div class="recomList-img">
              <router-link :to="{ path: midItem.url }">
                <img :src="midItem.pc_img"/>
              </router-link>
            </div>
          </div>
        </div>
        <div v-else-if="device =='mob'">
          <div class="midlist-bar midlist-bar-h5" v-if="configLists">
            <div class="midlist-content">
              <div class="text">{{ midItem.copywriting }}</div>
              <div class="button">
                <router-link :to="{ path: midItem.url }">
                  {{ midItem.button_text }}
                </router-link>
              </div>
            </div>
            <i class="mid-left"></i><i class="mid-right"></i>
          </div>
          <div class="recomList-bar" v-if="recomList">
            <div class="recomList-img">
              <router-link :to="{ path: midItem.url }">
                <img :src="midItem.h5_img"/>
              </router-link>
            </div>
          </div>
        </div>
</template>

<script>

import { mapState, mapActions } from "vuex";


export default {
    name: "NoData",
    data() {
        return {
          midItem: "",
        };
    },
    computed: {
      ...mapState({
        configList: (state) => state.home.configList,
      }),
    },
    props: {
      configLists: { type: Array },
      recomList: { type: Array },
    },
   mounted(){

    },
    beforeDestroy() {

    },
    methods: {

    },
    watch: {
      configLists() {
        let lists = this.configLists || this.configList
        for(const item of lists) {
          if (item.locationInfo.parameter=="index-center"){
            this.midItem = item
          }
        }
      },
      recomList() {
        let lists = this.recomList || this.configList
        for(const item of lists) {
          if (this.device =='web'){
            if (item.locationInfo.parameter=="pc-recommend-center"){
              this.midItem = item
            }
          }else{
            if (item.locationInfo.parameter=="H5-recommend-center"){
              this.midItem = item
            }
          }
        }
      },
    },
    components: {

    },
}
</script>

<style lang="scss" scoped>
.midlist-bar {
    background: url("@/assets/images/common/mid-bg.png") no-repeat center center;
    background-size: cover;
    min-height: 324px;
    width:100%;
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    .midlist-img{
      img{
        display: block;
        width: 100%;
        height: 100%;
      }
    }
    .midlist-content{
      min-height: 200px;
      display: flex;
      flex-direction: column;
      justify-content: space-evenly;
      align-items: center;
      .emoji{
        background: url("@/assets/images/common/emoji-g.png") no-repeat center center;
        width: 265px;
        height: 28px;
        background-size: cover;
      }
      .text{
        font-size: 24px;
        color: #fff;
      }
      .button{
        background: #EE1520;
        border-radius: 4px;
        font-weight: 700;
        font-size: 20px;
        letter-spacing: 0.3px;
        text-transform: uppercase;
        color: #F9F9F9;
        padding: 10px 30px;
        cursor: pointer;
        text-align: center;
        a{
          display: block;
          color: #fff;
        }
      }
    }
}
.recomList-bar {
  .recomList-img{
    img{
      display: block;
      width: 100%;
      height: 100%;
    }
  }
}
@media screen and (max-width:768px){
  .midlist-bar{
    background: #151515 url("@/assets/images/common/mid-bg.png") no-repeat center center;
    min-height: auto;
    background-size: contain;
    margin-top: 5%;
    position: relative;
    .midlist-content{
      min-height: 128px;
      .text{
        font-size: 16px;
      }
      .button{
        font-size: 14px;
      }
    }
    i{
      position: absolute;
      display: block;
      &.mid-left{
        background: url("@/assets/images/common/mid-left.png") no-repeat center center;
        background-size: cover;
        width: 27px;
        height: 27px;
        left: 30%;
        top: 2%;
      }
      &.mid-right{
        background: url("@/assets/images/common/mid-right.png") no-repeat center center;
        background-size: cover;
        width: 34px;
        height: 34px;
        right: 20%;
        top: 40%;
      }
    }
  }
}
</style>